import React from 'react';
import hoc from './FieldHOC';

export default hoc(function Surcharge(props) {
  const field = props.field;
  const percentage = field.prop('surcharge_type') === 'percentage' ? '(' + field.prop('surcharge_value') + '%)' : null

  return <div>
    {field.prop('field_hidden') && !FW.inEditor() ? null : <div style={{marginTop: 10, opacity: FW.inEditor() && field.prop('field_hidden') ? 0.5 : 1}}>
      <label>{field.prop('surcharge_title')}: ${parseFloat(field.getSurchargeValue()).toFixed(2)} {percentage}</label>
      {field.prop('surcharge_subtitle') ? <span><br />{field.prop('surcharge_subtitle')}</span> : null}
    </div>}
  </div>;
});
